export default __webpack_public_path__ + "static/media/BOPEN-BNB.283d5c36.svg";